module.exports = __webpack_public_path__ + "img/crossover_stopped.2aac0cc4.svg";